import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { mobilCallPhone } from 'services/media'
import { ModalConfirm } from 'components/Modals'

import styles from './styles'

const ModalConfirmToCall = ({
  telephone,
  contactName,
  message,
  openModal,
  onCancel,
  onConfirm
}) => {
  return (
    <div>
      <ModalConfirm
        isOpen={openModal}
        message={message}
        buttonConfirmLabel="Llamar ahora"
        onCancel={onCancel}
        onConfirm={() => {
          mobilCallPhone(telephone)
          onConfirm()
        }}
      >
        <p className="action-message">¿Deseas llamar a {contactName}?</p>
        <p className="telephone">{telephone}</p>
      </ModalConfirm>
      <style jsx>{styles}</style>
    </div>
  )
}

ModalConfirmToCall.propTypes = {
  telephone: PropTypes.string.isRequired,
  contactName: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  openModal: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ModalConfirmToCall
